import { Injectable } from '@angular/core';
import { Storage } from '../../context-discovery-services/models';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs';
declare var AzureStorage: any;

const cancelUploadFilter = {
    cancel: false,              // Set to true to cancel an in-progress upload
    loggingOn: false,            // Set to true to see info on console
    onCancelComplete: null,     // Set to a function you want called when a cancelled request is complete,
                                // i.e. when returnCounter==nextCounter. Because when you cancel an upload it can be many
                                // seconds before the in-progress chunks complete.
    nextCounter: 0,
    returnCounter: 0,
    handle: function (requestOptions, next) {
        const self = this;
        if (self.cancel) {
            self.log('cancelling before chunk sent');
            return;
        }
        if (next) {
            self.nextCounter++;
            next(requestOptions, function (returnObject, finalCallback, nextPostCallback) {
                self.returnCounter++;
                if (self.cancel) {
                    self.log('cancelling after chunk received');
                    if (self.nextCounter === self.returnCounter && self.onCancelComplete) {
                        self.onCancelComplete();
                    }
                    return;
                }
                if (nextPostCallback) {
                    nextPostCallback(returnObject);
                } else if (finalCallback) {
                    finalCallback(returnObject);
                }
            });
        }
    },
    log: function (msg) {
        if (this.loggingOn) {
            console.log('cancelUploadFilter: ' + msg + ' nc: ' + this.nextCounter + ', rc: ' + this.returnCounter);
        }
    },
};

@Injectable()
export class AzureBlobUploadService {

    blobUri: string;
    blobService: any;
    storageInfo: Storage;
    finishedOrError: boolean;
    progress$: Subject<number>;
    constructor() {
    }

    initializeAzureBlobClient(sasToken: string) {
        this.blobService = AzureStorage.Blob.createBlobServiceWithSas(this.storageInfo.storageUri, sasToken)
                            .withFilter(cancelUploadFilter);
    }

    uploadToBlobStorage(file: File, storageInfo: Storage, metadata: object): Observable<number> {
        this.progress$ = new Subject<number>();
        if (storageInfo) {
            this.storageInfo = storageInfo;
            this.initializeAzureBlobClient(this.storageInfo.sasToken);
            cancelUploadFilter.cancel = false;
            const speedSummary = this.uploadFile(file, metadata);
            this.refreshProgress(speedSummary, this.progress$);
        } else {
            this.progress$.error('Unable to upload file');
        }
        return this.progress$.asObservable();
    }

    uploadFile(file: File, metadata: object) {
        const customBlockSize = file.size > 1024 * 1024 * 32 ? 1024 * 1024 * 4 : 1024 * 512;
        this.blobService.singleBlobPutThresholdInBytes = customBlockSize;
        const options = {
            blockSize: customBlockSize
        };
        if (metadata) {
            options['metadata'] = metadata;
        }
        const speedSummary = this.blobService.createBlockBlobFromBrowserFile(
            this.storageInfo.container,
            this.storageInfo.filename,
            file,
            options,
            (error, _result, _response) => {
                if (error) {
                    console.log('Error: ', error);
                    this.progress$.error('Failed to upload. Please try again.');
                }
            }
        );
        return speedSummary;
    }

    cancelUpload() {
        this.progress$.complete();
        cancelUploadFilter.cancel = true;
        cancelUploadFilter.onCancelComplete = () => {
            console.log('Cancelled upload');
        };
    }

    refreshProgress(speedSummary: any, progress$: Subject<number>): void {
        setTimeout(() => {
            if (!progress$.hasError && !progress$.isStopped) {
                const progress = speedSummary.getCompletePercent();
                if (progress === '100.0') {
                    progress$.complete();
                } else {
                    progress$.next(progress);
                    this.refreshProgress(speedSummary, progress$);
                }
            }
        }, 200);
    }
}
